import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery } from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { alert } from "../../../../Utils/toast";
import { closeModal } from "../../modal/modal";
import { ReferralCodeForm } from "../../../../Components/Authentication/ReferralCodeModal/ReferralCodeModal";

export type PostReferralCodeLoadAction = {
  type: string;
  payload: ReferralCodeForm;
};
export type PostReferralCodeData = { data: { message: string } };
const PostReferralCode = new ReduxFetchState<PostReferralCodeData, ReferralCodeForm, any>(
  "postReferralCode",
);

export function* watchPostReferralCode(action: PostReferralCodeLoadAction) {
  try {
    const lang: "fa" | "en" = yield getCurrentLanguage();
    const { referral_code } = action.payload;

    const data: PostReferralCodeData = yield axios({
      url: `/api/v1/users/referrer/assign`,
      method: "POST",
      headers: { lang },
      data: {
        referral_code,
      },
    });

    yield put(PostReferralCode.actions.loadSuccess());
    yield put(closeModal());
    alert({ message: data?.data?.message, type: "success" });
    // setTimeout(() => {
    //   window.location.reload();
    // }, 1000);
  } catch (e: any) {
    const backendError = e?.response?.data?.error || e?.message || "Something went wrong";
    alert({ message: backendError, type: "error" });
    yield put(PostReferralCode.actions.loadFailure(e.message));
  }
}

export function* postReferralCodeSagas() {
  yield takeEvery(PostReferralCode.actionTypes.load, watchPostReferralCode);
}

export function usePostReferralCode() {
  const { loading, data, ...postReferralCodeState } = useAppSelector(
    (state) => state.postReferralCode,
  );
  const dispatch = useAppDispatch();

  const dispatchPostReferralCode = useCallback(
    (data: ReferralCodeForm) => {
      dispatch(PostReferralCode.actions.load(data));
    },
    [dispatch],
  );

  return {
    ...postReferralCodeState,
    dispatchPostReferralCode,
    postReferralCodeLoading: loading,
    postReferralCodeData: data,
  };
}

export const {
  actionTypes: postReferralCodeActionsTypes,
  actions: postReferralCodeActions,
  reducer: postReferralCodeReducer,
} = PostReferralCode;
